import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from "@/router/index.js";
import genres from "@/store/modules/genres";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    liveStreamInfoState: false,
    liveStreamInfoDataOne: {},
    liveStreamInfoDataTwo: {},
    error: {},
    selectedGenres: [],
    genresState: false
  },
  mutations: {
    setLiveStreamInfoState(state, payload) {
      state.liveStreamInfoState = payload;
    },
    setLiveStreamInfoDataOne(state, payload) {
      state.liveStreamInfoDataOne = payload;
    },
    setLiveStreamInfoDataTwo(state, payload) {
      state.liveStreamInfoDataTwo = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    setGenres(state, payload) {
      state.selectedGenres = payload;
    },
    setGenresState(state, payload) {
      state.genresState = payload;
    }
  },
  actions: {
    async setLiveStreamInfoDataOne(state) {
      const liveDataOne = await axios.get('https://movementathens.airtime.pro/api/live-info-v2');
      state.commit('setLiveStreamInfoDataOne', liveDataOne.data);
    },
    async setLiveStreamInfoDataTwo(state) {
      const liveDataTwo = await axios.get('https://movementathens2.airtime.pro/api/live-info-v2');
      state.commit('setLiveStreamInfoDataTwo', liveDataTwo.data);
    },
    resetErrorState(state) {
      state.commit('setError', {});
    },
    async setGenresState(state) {
      const genresEnabled = await axios.get(`${router.options.api}/front/is-genres-active`);
      state.commit('setGenresState', genresEnabled.data.active);
    }
  },
  modules: {
    genres
  },
  getters: {
    getLiveStreamInfoState: state => state.liveStreamInfoState,
    getLiveStreamInfoDataOne: state => state.liveStreamInfoDataOne,
    getLiveStreamInfoDataTwo: state => state.liveStreamInfoDataTwo,
    getError: state => state.error,
    getSelectedGenres: state => state.selectedGenres,
    getGenresState: state => state.genresState,
  }
});
